import {authRequest} from './index.js'

export async function get_interventions(trait_id, term_taxonomy_id = null){
  let data
  let url = 'traits/' + trait_id + '/interventions/'
  if (term_taxonomy_id){
    url = url + term_taxonomy_id
  }
  await authRequest.get(
    url
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_intervention(intervention_id){
  let data
  await authRequest.get(
    '/interventions/' + intervention_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_intervention_activites(intervention_id){
  let data
  await authRequest.get(
    '/interventions/' + intervention_id + '/activities'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function create_intervention(intervention){
  let data
  await authRequest.post(
    '/interventions',
    { intervention },
    { headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 1000 * 60
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function update_intervention(intervention_id, intervention){
  let data
  await authRequest.patch(
    '/interventions/' + intervention_id,
    { intervention },
    { headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 1000 * 60
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_trait_intervention(id){
  let data
  await authRequest.get(
    'traits/' + id.trait +
    '/childrens/' + id.child +
    '/interventions',
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function delete_intervention(intervention_id){
  let data
  await authRequest.delete(
    '/interventions/' + intervention_id,
    { headers: {
      'Content-Type': 'application/json'
    }
  }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}

export async function get_recent_uploads(limit = 10){
  let data
  await authRequest.get(
    '/interventions/recent_uploads',
    { params: { limit } }
  )
  .then(function(result){
    data = {result: result.data, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, isRedirecting: error.isRedirecting, result: error.response?.data, message: error.message, statusCode: error.statusCode}
  })
  return data
}